import { IonFabButton } from "@ionic/react";
import { IEvent } from "./IWebsiteDataV3";

export const Event: React.FC<{ event: IEvent; }> = ({ event }) => {
    return (
        <div style={{ margin: 10 }} >
            <div className="event-wrapper-1">
                <div style={{ position: 'relative'}}>
                    <figure className="event-img" onClick={() => {
                        if (event.videoUrl){
                            window.open(event.videoUrl, '_blank');
                        }
                    }}>
                        <img src={event.imagePath} alt="" />
                        {event.videoUrl && (
                            // TODO: ideally top would be half the image height but that currently varies
                            <div style={{ position: 'absolute', top: 75, left: 340 / 2 - 20  }}>
                                <IonFabButton>
                                    <i style={{ fontSize: 36, color: 'var(--ion-color-light)'  }} className="fa-solid fa-play" />
                                </IonFabButton>
                            </div>
                        )}

                        <div className="event-date"><i className="fa fa-calendar"></i> {event.date}</div>
                    </figure>
                </div>
                <div className="event-content">
                    <h5>
                        {event.url && (
                            <a href={event.url}>
                                {event.name}
                            </a>
                        )}
                        {!event.url && (
                            <span>{event.name}</span>
                        )}

                    </h5>
                    <p>
                        {event.description}
                        <br />
                        <br />
                        {event.location}
                    </p>
                    {event.url && (
                        <span className="btn-read-more"><a href={event.url}>
                            Read More &raquo;
                        </a></span>
                    )}
                </div>
            </div>
        </div>
    );
}
